import { defineStore } from 'pinia'
import { useNuxtApp } from '#app'

import { StoreId } from '@/store'
import { TimeState } from '@/store/basket/basket.types'
import { Success } from '@/api/results'

/* Utils */
import { getListOfMonth } from '@/store/basket/basket.utils'

const defaultState: TimeState = {
  delivery_at: '',
  delivery_at_text: '',
  error: '',
  choices: [],
  message: '',
  variants: [],
  warning: '',
  warning_icon: '',
}

export const useBasketTimeStore = defineStore({
  id: StoreId.BASKET_TIME,
  state: (): TimeState => defaultState,
  actions: {
    setTime(newTimeState: Partial<TimeState>) {
      Object.assign(this.$state, newTimeState)
    },

    async getAvailableTime(props: {
      delivery_at_client: boolean
      delivery_at?: string
    }) {
      const { $apiService } = useNuxtApp()

      this.setTime({
        delivery_at: defaultState.delivery_at,
      })

      const result = await $apiService.basket.getAvailableTime(props)

      if (result instanceof Success) {
        this.setTime(result?.data || defaultState)

        return
      }

      this.setTime({ error: result.message })
    },

    async getDateChoices() {
      const { $apiService } = useNuxtApp()

      const result = await $apiService.basket.getDateChoices()

      if (result instanceof Success) {
        return result.data
      }

      return getListOfMonth()
    },

    async getTimeChoices({ date }: { date: string }) {
      const { $apiService } = useNuxtApp()

      this.setTime({
        delivery_at: defaultState.delivery_at,
        warning: defaultState.warning,
        variants: defaultState.variants,
      })

      const result = await $apiService.basket.getTimeChoices({ date })

      if (result instanceof Success) {
        this.setTime(result?.data || defaultState)

        return
      }

      this.setTime({ error: result.message })
    },
  },
})
